import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    FunctionField,
    NumberInput,
    ReferenceField,
    ReferenceInput,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    Toolbar,
    useRecordContext,
} from 'react-admin'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.email}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <InputGuesser label='Name' source='name' fullWidth isRequired validate={[required()]} />
            <ReferenceInput source='town' reference='towns' isRequired>
                <SelectInput optionText='name' isRequired fullWidth />
            </ReferenceInput>

            <NumberInput source='latitude' fullWidth />
            <NumberInput source='longitude' fullWidth />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <FieldGuesser label='Name' source='name' />
        <ReferenceField source='town' reference='towns' sortable={false}>
            <FunctionField render={(record) => record.name} />
        </ReferenceField>
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => <Fields Guesser={ShowGuesser} title={<Title />} {...props} />

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const Commune = {
    list: List,
    edit: Edit,
    create: Create,
    show: Show,
}

export default Commune
